import {ActionTypes} from './../../cc-imports'
import _ from 'lodash';

const initialState = {
    modals : [],
    random : 0
};


const ModalsReducers = (state = initialState, action = {}) => {

    switch (action.type) {
        case (ActionTypes.OPEN_MODAL) :
            var modals = _.unionBy(state.modals, [action.payload], 'name')
            return {...state, modals: modals, random:Math.random() }
        case (ActionTypes.CLOSE_MODAL) :
            var modals = state.modals;
            _.remove(modals,(modal)=>{
                return modal.name==action.payload.name
            });
            return {...state, modals: modals, random:Math.random() }
        default :
            return state;
    }
};

export default ModalsReducers;



// WEBPACK FOOTER //
// ./src/app/data/reducers/ModalsReducers.js